/**
 * Created by pandemio on 3/29/19.
 */
import React from 'react';
import { Redirect } from "react-router-dom";
import { Container, FormGroup, Col, Label, Row, Button} from 'reactstrap';
/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import global from "../translations/global.json";
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import LanguageManager from '../custom-classes/language-manager';
import Footer from './footer/footer';
import NavbarDesktop from './navbar/navbar-desktop-top';
import NavbarMobile from './navbar/navbar-mobile';
import FormGroupUsername from './forms/form-group-username';
import FormGroupName from './forms/form-group-name';
import ApiCalls from '../custom-classes/api-calls';
import LoaderFullWindow from './loader-windows/loader-full-window';
import ModalGeneric from './modals/modal-generic';
import ModalAttachProfile from './modals/modal-add-existing-profile-caution';
import ProfilesDataTable from './datatables/profiles-data-table';

import FormGroupNewPassword from './forms/form-group-new-password';
import ModalSuccessSetupProfile from './modals/modal-success-setup-profile-first-time';
import SelectorSex from './selectors/selector-sex';
import DatePicker from './date-picker/date-picker';
import moment from 'moment';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

/**
 * The component (window) to set the profile to subscription for an existing client
 */
class SubscriptionSetProfileExistingAccount extends React.Component{


    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage() }
        });
        this.props.addTranslation(global);

        this.state = {
            profileId: '',
            profileFullName: '',
            subscriptionId: props.location.subscriptionId,
            mobile: false,
            didMount: false,
            loading: false,
            showErrorModal: false,
            createdAt: moment(),
            firstName: '',
            lastName: '',
            password: '',
            passwordRetype: '',
            username: '',
            dob: null,
            sex: '',
            validPassword: false,
            usernameAvailable: true,
            validUsername: false,
            validFirstName: false,
            validLastName: false,
            propsModal: null,
            propsModalAddNewProfile: null,
            calendarFocused: false,
            proceedSubmit: false,
            showAddNewProfileModal: false, // Shows the modal to add a new user right now
            transactionSuccess: false,
            goToDashboard: false,
            goToDownload: false,
            spacesLeft: false,
            showModalAttachCaution: false,
            visibleModalAttach: false,
            redoSearch: false
        };

        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.toggleSuccessModal = this.toggleSuccessModal.bind(this);
        this.toggleAttachProfile = this.toggleAttachProfile.bind(this);

        this.setSubmitButtonState = this.setSubmitButtonState.bind(this);
        this.submitRegister = this.submitRegister.bind(this);
        this.toggleAlertModal = this.toggleAlertModal.bind(this);
        this.toogleAlertAddNewProfile = this.toogleAlertAddNewProfile.bind(this);
        this.handleExistingAccountSelected = this.handleExistingAccountSelected.bind(this); 
    }

    handleExistingAccountSelected(e){
        this.setState({
            profileId: e.value,
            profileFullName: e.GivenName + ' ' + e.Surname + ' (' + e.Username + ')',
            showModalAttachCaution: true
        });
    }

    toggleAttachProfile(e){
        this.setState({
            showModalAttachCaution: !this.state.showModalAttachCaution
        },()=>
        {
            // If the user answered a yes to insert the existing account, then add it.
            if(e.answer)
                this.subtmitSelectedStudent();
        });
    }

    /** Toggles the alert modal, and according to the response, it sends it to the whatever it needs to be sent **/
    toogleAlertAddNewProfile(data){
        this.setState({showAddNewProfileModal: false});

        if(this.state.transactionSuccess && !data.answer)
        {
            this.setState({goToDownload: true},()=>
            {
                // Updates the parent (send it owns to state to update it)
                this.props.updateParent(this.state);
                return this.state;
            });
        }

        if(this.state.cameFromRegister && !data.answer && this.state.transactionSuccess) {
            this.setState({goToDownload: true},()=>
            {
                // Updates the parent (send it owns to state to update it)
                this.props.updateParent(this.state);
                return this.state;
            });
        }
        else if (this.state.transactionSuccess && !this.state.cameFromRegister && !data.answer) {
            this.setState({goToDashboard: true},()=>
            {
                this.props.updateParent(this.state);
                return this.state;
            });
        }
    }

    /**
     * Sets if submit button is ready or not
     */
    setSubmitButtonState() {

        this.setState({
            proceedSubmit: (
            this.state.validFirstName &&
            this.state.validLastName &&
            this.state.validPassword &&
            this.state.validUsername &&
            this.state.usernameAvailable &&
            this.state.subscriptionId != null && this.state.subscriptionId.length > 0)
        });
    }

    /**
     * Saves the username state and verifies if the next button is ready
     * @param field
     */
    saveUsername = (field) => (newValue) => {
        this.setState({
            'username': newValue.username,
            'validUsername': newValue.validUsername,
            'usernameAvailable': newValue.usernameAvailable
        }, () => {
            this.setSubmitButtonState();
        });
    };

    /**
     * Save the password state and verifies if the next button is ready
     * @param field
     */
    savePassword = (field) => (newValue) => {
        this.setState({
            'password': newValue.password,
            'passwordRetype': newValue.passwordRetype,
            'validPassword': newValue.validPassword
        }, () => {
            this.setSubmitButtonState();
        });
    };

    /**
     * Save the name details and verifies if the next button is ready
     * @param field
     */
    saveName = (field) => (newValue) => {
        this.setState({
            'firstName': newValue.firstName,
            'lastName': newValue.lastName,
            'validFirstName': newValue.validFirstName,
            'validLastName': newValue.validLastName
        }, () => {
            this.setSubmitButtonState();
        });
    };

    /**
     * Submit register
     */
    submitRegister() {

        this.setState({
            loading: true
        },()=>{
            // Submits the registration
            let apiCall = ApiCalls.registerProfile(this.state.subscriptionId,
                this.state.username,
                this.state.password, this.state.passwordRetype,
                this.state.firstName, this.state.lastName,
                this.state.sex, this.state.dob);

            apiCall.then((returned)=> {
                this.setState({loading: false}, ()=> {
                    // Reset fields
                    if (returned.TransactionValid) {

                        this.setState({
                            firstName: '',
                            lastName: '',
                            password: '',
                            passwordRetype: '',
                            username: '',
                            dob: null,
                            sex: '',
                            validPassword: false,
                            usernameAvailable: true,
                            validUsername: false,
                            validFirstName: false,
                            validLastName: false,
                            createdAt: moment(),
                            calendarFocused: false,
                            proceedSubmit: false,
                            transactionSuccess: true
                        },()=> {
                            let propsModal = {
                                bodyText: returned.Messages[0],
                                visible: true
                            };
                            this.setState({propsModal: propsModal, showErrorModal: true,  redoSearch: true},()=>{
                                this.setState({
                                    redoSearch: false
                                })
                            });
                        });
                    }
                    else
                    {
                        let propsModal = {
                            bodyText: returned.Messages[0],
                            visible: true
                        };
                        this.setState({propsModal: propsModal, showErrorModal: true,  redoSearch: false});
                    }
                })
            });
        });
    }

    /**
     * Saves the sex
     * @param field
     */
    saveSex = (field) => (newValue) => {
        this.setState({'sex': newValue}, ()=> {
            this.setSubmitButtonState();
        });
    };

    /**
     * Saves the DOB
     * @param field
     */
    saveDob = (field) => (newValue)=> {
        this.setState({'dob': newValue.date}, ()=> {
            this.setSubmitButtonState();
        });
    };

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.setState({didMount: true},()=>{

        });
    }

    /**
     * Toggles the success modal
     */
    toggleSuccessModal(){
        this.setState({showModalSuccess: false});
    }

    /**
     * Toogles alert modal
     */
    toggleAlertModal() {
        this.setState({showErrorModal: false});
    }

    /** Submits the selected student to the profile **/
    subtmitSelectedStudent()
    {
        this.setState({
            loading: true
        },()=> {
            // Submits the registration
            let apiCall = ApiCalls.insertSubscriptionToUser(this.state.profileId, this.state.subscriptionId);
            apiCall.then((returned)=> {
                // Show general alert
                let propsModal = {
                    bodyText: returned.Messages[0],
                    visible: true
                };
                this.setState({propsModal: propsModal, showErrorModal: true, loading: false});
            });
        });
    }

    /**
     * To evaluate when the screen size changed
     */
    resize() {
        this.setState({mobile: window.screen.width <= 1024});
    }

    /**
     * Renders the landing page
     * @returns {XML}
     */
    render()
    {
        if(this.state.subscriptionId === null
            || typeof this.state.subscriptionId === 'undefined'
            || this.state.subscriptionId === '')
            return (<Redirect  to={{
                pathname: "/dashboard"
            }}/>);

        return (
            <div>
                {this.state.mobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding card-white">
                    <Container className="margin-top-mandatory-60">
                        <Row>
                            <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <h1 className="font-now-bold centered-text">
                                    <Translate id="subscription-set-profile-existing-account.title"/>
                                </h1>
                            </Col>
                        </Row>

                        <Row>
                            <h2><Translate id="subscription-set-profile-existing-account.existing-profile-instructions"/></h2>
                            <Col style={{border: 'solid lightgray', backgroundColor: 'whitesmoke'}}
                                 xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <hr/>
                                <ProfilesDataTable redoSearch={this.state.redoSearch} updateParent={this.handleExistingAccountSelected}/>
                            </Col>
                        </Row>
                        <hr/>
                        <Row>
                            <Col xs={{size: 12}} sm={{size: 12}} md={{size: 6}} lg={{size: 6}}>
                                <h2><Translate id="subscription-set-profile-existing-account.or-add-new-profile-instructions"/></h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{border: 'solid lightgray', backgroundColor: 'whitesmoke'}}
                                 xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <Row className="margin-top-10">

                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 6}} lg={{size: 6}}>
                                        <FormGroupUsername data={this.state} updateParent={this.saveUsername()}/>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroupNewPassword data={this.state} updateParent={this.savePassword()}/>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroupName data={this.state} updateParent={this.saveName()}/>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 6}} lg={{size: 6}}>
                                        <FormGroup row>
                                            <Col sm={{size: 12}}>
                                                <Label for="sex">
                                                    <Translate id="profile-register.sex"/>
                                                </Label>
                                                <SelectorSex data={this.state} updateParent={this.saveSex()}/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <FormGroup row>
                                            <Col sm={{size: 12}}>
                                                <Label for="dob">
                                                    <Translate id="profile-register.dob"/>
                                                </Label>
                                                <DatePicker data={this.state} updateParent={this.saveDob()}/>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <hr/>
                                <Row>
                                    <Col xs={{size:12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                        <Button block color="success" className="font-now" onClick={this.submitRegister}>
                                            <h2><Translate id="profile-register.submit-profile"/></h2>
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>

                </div>
                {this.state.loading ? <LoaderFullWindow/> : null}
                {this.state.showErrorModal ? <ModalGeneric data={this.state.propsModal} updateParent={this.toggleAlertModal}/> : null}
                {this.state.showAddNewProfileModal ?
                    <ModalSuccessSetupProfile visible={this.state.showAddNewProfileModal} spacesLeft={this.state.spacesLeft}
                                              updateParent={this.toogleAlertAddNewProfile} />  : null}
                {this.state.showModalAttachCaution ?
                    <ModalAttachProfile visibleModalAttach={this.state.showModalAttachCaution}
                                        studentName={this.state.profileFullName}
                                        updateParent={this.toggleAttachProfile}
                    /> : null
                }
                <Footer/>
            </div>
        )
    }
}
export default withLocalize(SubscriptionSetProfileExistingAccount);